<template>
    <div>
       <h4 class="title">註冊會員身分驗證</h4>
       <div class="member_content">
            
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Active',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/'
    }
  },
  mounted: function () {
    let data = {
      verifycode: this.$route.params.verifycode,
      id: this.$route.params.id
    }
    this.active(data)
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    active (data) {
      let str = ''
      if (data.verifycode === '') {
        str += '驗證代碼錯誤\n'
      }
      if (str === '') {
        this.$http.post(this.apiurl + 'api/avticeMember', {
          activecode: data.verifycode,
          userid: data.id
        }).then(function (res) {
          let data = res.body.data
          if (data.status === 200) {
            window.alert('會員驗證啟動成功。')
          } else {
            window.alert('會員驗證失敗。')
          }
          // this.$router.go('/')
        }, function () {
          console.log('failed')
        })
      } else {
        window.alert(str)
      }
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Active.vue?4bb029cc